export default {"src":"/_next/static/media/icon_aram.25ee8532.svg","height":20,"width":17,"blurWidth":0,"blurHeight":0};